import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["description", "name", "companyName", "imageSrc", "linkMode", "listingHref", "badgesSlot", "bottomSlot", "onLinkClick", "ribbonSlot", "topRightSlot", "providerName"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AgentIconWithFallback } from 'ai-components-ui-library/components/icons/AgentIconWithFallback';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import styled from 'foundations-theming/utils';
import { useState } from 'react';
import { useLazyImage } from '../LazyImageProvider';
import { PolymorphicLink } from '../PolymorphicLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTopRightSlotWrapper = styled.div.withConfig({
  displayName: "EcosystemCardMedium__StyledTopRightSlotWrapper",
  componentId: "sc-8amvl0-0"
})(["position:absolute;inset-inline-end:", ";inset-block-start:", ";opacity:", ";:focus-within{opacity:1;}"], ({
  theme
}) => theme.space['600'], ({
  theme
}) => theme.space['600'], ({
  isHovered
}) => isHovered ? 1 : 0);
const StyledUnderlineOnHover = styled.div.withConfig({
  displayName: "EcosystemCardMedium__StyledUnderlineOnHover",
  componentId: "sc-8amvl0-1"
})(["&:hover{text-decoration:underline;}"]);
export function EcosystemCardMedium(_ref) {
  let {
      description,
      name,
      companyName,
      imageSrc,
      linkMode = 'default',
      listingHref,
      badgesSlot,
      bottomSlot,
      onLinkClick,
      ribbonSlot,
      topRightSlot,
      providerName
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const imageLoadingMode = useLazyImage();
  const [isHovered, setIsHovered] = useState(false);
  const linkProps = {
    href: listingHref,
    linkMode,
    onClick: onLinkClick,
    use: 'unstyled'
  };
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    compact: true,
    onMouseEnter: () => topRightSlot && setIsHovered(true),
    onMouseLeave: () => topRightSlot && setIsHovered(false)
    // this is set to "ecosystem-app-card" to make for easy migration off our legacy components
    ,
    "data-test-id": "ecosystem-app-card"
  }, props, {
    children: /*#__PURE__*/_jsxs(CardSection, {
      children: [ribbonSlot, /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
        tabIndex: -1,
        "aria-hidden": true,
        children: /*#__PURE__*/_jsx(AgentIconWithFallback, {
          iconUrl: imageSrc,
          loading: imageLoadingMode,
          marginBlockEnd: "0",
          name: name,
          size: 48
        })
      })), /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          typography: "heading-100",
          overflowWrap: "break-word",
          marginBlockStart: "400",
          children: /*#__PURE__*/_jsx(StyledUnderlineOnHover, {
            children: name
          })
        })
      })), /*#__PURE__*/_jsx(StyledTopRightSlotWrapper, {
        isHovered: isHovered,
        children: topRightSlot
      }), /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        paddingBlockStart: "100",
        tabIndex: -1,
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "trellisEcosystem.appCard.providerName",
            options: {
              providerName: companyName !== null && companyName !== void 0 ? companyName : providerName
            }
          })
        })
      })), /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
        children: /*#__PURE__*/_jsx(Text, {
          marginBlockStart: "200",
          children: description
        })
      })), badgesSlot && /*#__PURE__*/_jsx(Flex, {
        alignItems: "end",
        gap: "200",
        marginBlockStart: "auto",
        paddingBlockStart: "400",
        children: badgesSlot
      }), bottomSlot && /*#__PURE__*/_jsx(Flex, {
        marginBlockStart: "500",
        children: bottomSlot
      })]
    })
  }));
}